module.exports = __webpack_public_path__ + "assets/img/zhencha-891d5e8d.png";